import { CreditCard } from 'lucide-react';
import { Modal } from '../../elements/Modal';
import { useNavigate } from 'react-router-dom';

interface BillingRequiredModalProps {
  open: boolean;
  onClose: () => void;
}

export default function BillingRequiredModal({
  open,
  onClose,
}: BillingRequiredModalProps) {
  const navigate = useNavigate();

  const handleSetUpBilling = () => {
    onClose();
    navigate('/account');
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="relative w-20 h-20 flex items-center justify-center">
            <div className="absolute inset-0 bg-amber-500/20 rounded-full" />
            <div className="relative w-16 h-16 rounded-full border-2 border-amber-500 flex items-center justify-center bg-brand-surface">
              <CreditCard className="w-8 h-8 text-amber-500" />
            </div>
          </div>
        </div>

        <h2 className="text-2xl font-bold text-neutral-light mb-4">Add Payment Method</h2>

        <p className="text-text-muted mb-8">
          To launch your campaign, please add a payment method first. You'll only be charged when you receive qualified leads.
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={handleSetUpBilling}
            className="w-full px-6 py-3 bg-amber-600 hover:bg-amber-500 text-white font-medium rounded-lg transition-colors"
          >
            Set Up Billing
          </button>
          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-transparent hover:bg-brand-hover text-text-muted font-medium rounded-lg transition-colors border border-gray-700"
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
}
